import { ProviderInfo, RecoverAccount, UserInfo } from './application.types';

export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const SET_AUTH_LOADING = 'SET_AUTH_LOADING';
export const SET_AUTH_DATA = 'SET_AUTH_DATA';
export const SET_PROVIDER_INFO = 'SET_PROVIDER_INFO';
export const LOGOUT = 'LOGOUT';
export const SET_PROVIDERS = 'SET_PROVIDERS';
export const SET_RECOVER_ACCOUNT = 'SET_RECOVER_ACCOUNT';
export const SET_RECOVER_ACCOUNT_INITIAL_STATE = 'SET_RECOVER_ACCOUNT_INITIAL_STATE';

export type ApplicationActionType =
  | InitializeAuth
  | Logout
  | SetAuthData
  | SetAuthLoading
  | SetProviderInfo
  | SetProviders
  | SetRecoverAccount
  | SetRecoverAccountInitialState;

export interface InitializeAuth {
  payload: object;
  type: typeof INITIALIZE_AUTH;
}

export interface Logout {
  payload: object;
  type: typeof LOGOUT;
}

export interface SetAuthData {
  payload: {
    token: string;
    userInfo: UserInfo;
  };
  type: typeof SET_AUTH_DATA;
}

export interface SetAuthLoading {
  payload: { isLoading: boolean };
  type: typeof SET_AUTH_LOADING;
}

export interface SetProviderInfo {
  payload: ProviderInfo;
  type: typeof SET_PROVIDER_INFO;
}

export interface SetProviders {
  payload: { providers: ProviderInfo[] };
  type: typeof SET_PROVIDERS;
}

export interface SetRecoverAccount {
  payload: RecoverAccount;
  type: typeof SET_RECOVER_ACCOUNT;
}

export interface SetRecoverAccountInitialState {
  payload: object;
  type: typeof SET_RECOVER_ACCOUNT_INITIAL_STATE;
}
